import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EntradaDetalharRoutingModule } from "./entrada-detalhar-routing.module";
import { EntradaDetalharComponent } from "./entrada-detalhar.component";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { FormsModule } from "@angular/forms";
import { TableModule } from "primeng/table";
import { InputMaskModule } from "primeng/inputmask";
import { FormatPipeModule } from "src/app/admihair/format-pipe/format-pipe.module";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { MessagesModule } from "primeng/messages";





@NgModule({
    imports: [
        CommonModule,
        EntradaDetalharRoutingModule,
        FormsModule,
        TableModule,
        ButtonModule,
        InputTextModule,
        InputMaskModule,
        FormatPipeModule,
        MessagesModule,
        ProgressSpinnerModule

    ],
    declarations: [EntradaDetalharComponent]
})
export class EntradaDetalharModule { }
